import { useEffect, useState } from "react"
import { getItemWebStorage } from "../../../features/webStorageSaver"
import { useLazyFetchAnalyticsReportQuery } from "../../../api/rtk/base/slices/analyticsApiSlice"
import { Loader } from "../../loaders/Loader"

const objectTypesOverallAnalyticsCaptions: any = {
    RoadRiverBridges: "Мосты",
    RoadFerrys: "Паромные и понтонные переправы",
    RoadControlPosts: "КПП",
}

export default function ObjectTypesInfoPanelContent({ objectTypesNames }: any) {

    const [objectTypesInfo, setObjectTypesInfo] = useState<any>(null)
    const [objectTypesInfoIsFetching, setObjectTypesInfoIsFetching] = useState<boolean>(true)
    const [infoPanelIsShown, setInfoPanelIsShown] = useState<boolean>(true)
    const [fetchObjectTypeInfo] = useLazyFetchAnalyticsReportQuery()

    useEffect(() => {
        if (objectTypesNames) {
            getObjectTypesInfo()
        }
    }, [objectTypesNames])

    async function getObjectTypesInfo() {
        setObjectTypesInfoIsFetching(true)
        const objectTypes = getItemWebStorage("objectTypes")
        let objectTypesInfoObject = {}
        let hasAtLeastOneFilled = false
        await Promise.all(objectTypesNames.map(async (objectTypeName: any) => {
            let { classId: objectTypeClassId, caption } = objectTypes.find((objectType: any) => objectType.name === objectTypeName) ?? {}
            const { data: objectTypeInfoResponse } = await fetchObjectTypeInfo({ classId: objectTypeClassId })
            const objectTypeInfo = objectTypeInfoResponse?.AggregateReport[0]
            const number = parseFloat(objectTypeInfo?.["Количество"])
            const length = objectTypeInfo?.["Протяжённость, км"]
            const overallAnalyticsCaption = objectTypesOverallAnalyticsCaptions[objectTypeName]
            if (overallAnalyticsCaption) {
                caption = overallAnalyticsCaption
            }
            let formattedObjectTypeInfo = { caption, number, length }
            if (number || length) {
                hasAtLeastOneFilled = true
                objectTypesInfoObject = { ...objectTypesInfoObject, [objectTypeName]: formattedObjectTypeInfo }
            }
        }))
        setObjectTypesInfoIsFetching(false)
        setInfoPanelIsShown(hasAtLeastOneFilled)
        setObjectTypesInfo(objectTypesInfoObject)
    }

    function getObjectTypeImage(objectTypeName: any) {
        const lowerCaseFirstLetter = objectTypeName[0].toLowerCase()
        const remainingString = objectTypeName.substr(1)
        const formattedObjectTypeName = `${lowerCaseFirstLetter}${remainingString}`
        try {
            return require(`../../../assets/images/icons/overallAnalytics/${formattedObjectTypeName}.svg`)
        } catch {
            console.error(`Ошибка загрузки изображения ${`../../assets/images/icons/overallAnalytics/${formattedObjectTypeName}.svg`}`)
        }
    }

    return (
        <>
            {objectTypesInfoIsFetching && <Loader />}
            {infoPanelIsShown
                ?
                <div className="object-types-info-panel-content">
                    {objectTypesNames.map((objectTypeName: any) => {
                        const objectTypeInfo = objectTypesInfo?.[objectTypeName]
                        const { number, length, caption } = objectTypeInfo ?? {}
                        if (number || length) {
                            return (
                                <div className="object-type-info-block">
                                    <div className="image-div">
                                        <img src={getObjectTypeImage(objectTypeName)} />
                                    </div>
                                    <div className="object-type-info-text">
                                        <span>{caption}{number && <span> - {number} шт.</span>}</span>
                                        {length && <span>{length} км</span>}
                                    </div>
                                </div>
                            )
                        }
                    })}
                </div>
                :
                <div className="panel-no-content">
                    <span>Нет информации</span>
                </div>
            }
        </>
    )
}
